export default function Contact() {
  return (
    <section id="contact" className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3983fcbbbfd81928b6843ea9496a304e.jpg"
          alt="Canada Map Background"
          title="Canada map - McALLISTER DELIGHT service area"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A365D]/95 via-[#1A365D]/90 to-[#DC2626]/85"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-6 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <div className="w-16 h-16 md:w-24 md:h-24 rounded-full border-2 border-white flex items-center justify-center mx-auto mb-6 md:mb-8">
            <i className="ri-mail-line text-3xl md:text-5xl text-white"></i>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 md:mb-6">Get In Touch</h2>
          <p className="text-gray-200 text-base md:text-xl max-w-2xl mx-auto">
            Have questions or need a personalized logistics quote? Reach out to us — we&apos;re happy to help.
          </p>
        </div>

        <div className="flex justify-center">
          <a
            href="mailto:info@mcallisterdelight.com"
            className="group w-full max-w-lg cursor-pointer"
          >
            <div className="bg-white rounded-2xl px-8 py-6 md:px-10 md:py-8 flex items-center gap-5 md:gap-6 group-hover:bg-gray-50 transition-all duration-300 group-hover:scale-[1.02]">
              {/* Icon */}
              <div className="w-14 h-14 md:w-16 md:h-16 flex-shrink-0 rounded-xl bg-[#DC2626] flex items-center justify-center group-hover:bg-[#B91C1C] transition-colors">
                <i className="ri-mail-send-line text-2xl md:text-3xl text-white"></i>
              </div>

              {/* Text */}
              <div className="flex-1 min-w-0">
                <p className="text-[#1A365D] font-bold text-lg md:text-xl mb-0.5">
                  Send Us an Email
                </p>
                <p className="text-gray-500 text-sm md:text-base truncate">
                  info@mcallisterdelight.com
                </p>
                <p className="text-gray-400 text-xs mt-1.5 flex items-center gap-1">
                  <i className="ri-information-line"></i>
                  Opens your email client
                </p>
              </div>

              {/* Arrow */}
              <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full bg-gray-100 group-hover:bg-[#DC2626] transition-colors">
                <i className="ri-arrow-right-line text-gray-400 group-hover:text-white transition-colors text-lg"></i>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
